import React from "react";

import {
  getNorthbeamUtmPlatformParams,
  NorthbeamUtmPlatform,
} from "@features/utm-guide";
import reSci from "@features/utm-guide/images/reSci.png";

export function RetentionScience() {
  const urlParamPairs = getNorthbeamUtmPlatformParams({
    platform: NorthbeamUtmPlatform.RETENTION_SCIENCE,
  });
  return (
    <div className="flex flex-col gap-3">
      <p className="mb-0">
        For each of the following parameter pairs, input them into{" "}
        <b>Retention Science</b> on the <b>UTM Settings</b> page.
      </p>
      <img className="img-fluid mb-3" src={reSci} alt="" />
      <table className="table table-bordered table-striped table-sm bg-white">
        <thead>
          <tr>
            <th>Key</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          {urlParamPairs.map(({ key, value }) => (
            <tr key={key}>
              <td>{key}</td>
              <td>{value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
